export default __webpack_public_path__ + "static/screen-web@2x-417a9ac46e3887cdeb163eb353f438aa.png";